<template>
  <div>
    <div class="banner">
      <img src="../assets/logo.svg" style="width: 12rem" alt />
    </div>
    <div class="home" :style="`--primary-color: ${meta.headingColor.hex}`">
      <div class="headline-container">
        <div class="loading-indicator" v-if="this.$apollo.queries.meta.loading">
          Loading
        </div>
        <div
          v-else
          class="headline"
          v-html="markdownString(meta.richText)"
        ></div>
      </div>
      <router-view />
      <div id="nav">
        <div
          class="loading-indicator"
          v-if="this.$apollo.queries.pageTypes.loading"
        >
          Loading
        </div>
        <div v-else class="select-container">
          <span class="select-heading">{{ meta.selectPageTypeHeading }}</span>
          <select
            class="select"
            name="pagetype-selector"
            v-model="selectedPageType"
            id="pagetype-selector"
          >
            <option
              v-for="(option, k) in pageTypes"
              :key="k"
              :value="option.id"
            >
              {{ option.pageTypeDescription }}</option
            >
          </select>
        </div>
        <div
          class="loading-indicator"
          v-if="this.$apollo.queries.pageTypes.loading"
        >
          Loading
        </div>
        <div v-else class="grid container">
          <div
            v-for="(item, o) in filterPageTypes(selectedPageType, pageTypes)"
            :key="o"
            class="item"
          >
            <router-link
              :to="{
                name: 'Card',
                params: {
                  id: item.id,
                  richText: item.richText,
                  color: meta.headingColor,
                },
              }"
              class="navigation-link w-full h-full"
            >
              <img
                v-if="item.navigationIcon"
                class="navigation-icon"
                :src="item.navigationIcon.url"
              />
              <img
                v-else
                src="../assets/navigation-icon-default.svg"
                class="navigation-icon"
                alt
              />
              <span class="navigation-text">{{ item.title }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import showdown from "showdown";

import gql from "graphql-tag";

export default {
  name: "Home",
  data() {
    return {
      selectedPageType: null,
    };
  },
  watch: {
    selectedPageType(newPageType) {
      localStorage.setItem("selectedPageType", newPageType);
    },
  },
  components: {},

  computed: {
    organisePages() {
      function compare(a, b) {
        if (a === b) {
          return 0;
        } else if (a.priority === null) {
          return 1;
        } else if (b.priority === null) {
          return -1;
        }
        return b.priority < a.priority ? 1 : -1;
      }
      const pages = Array.isArray(this.pages)
        ? [...this.pages].sort(compare)
        : [];
      return pages;
    },
  },
  mounted() {
    if (localStorage.getItem("selectedPageType")) {
      return (this.selectedPageType = localStorage.getItem("selectedPageType"));
    }
  },
  beforeUpdate() {
    if (!localStorage.getItem("selectedPageType")) {
      this.selectedPageType = this.pageTypes[0].id;
    }
  },
  methods: {
    markdownString(markdownString) {
      let converter = new showdown.Converter();
      let output;
      output = converter.makeHtml(markdownString);
      return output;
    },
    filterPageTypes(selectedPageTypeID, pageTypes) {
      const filterPagesByType = pageTypes.filter(
        (pageType) => pageType.id === selectedPageTypeID
      );
      return filterPagesByType[0].pages;
    },
  },
  apollo: {
    pages: gql`
      query {
        pages {
          title
          id
          richText
          priority
          navigationIcon {
            id
            url
            width
            height
          }
        }
      }
    `,
    pageTypes: gql`
      query {
        pageTypes {
          pageTypeDescription
          id
          pages {
            id
            title
            richText
            navigationIcon {
              id
              url
              width
              height
            }
          }
        }
      }
    `,
    meta: gql`
      query {
        meta(where: { id: "ckdhv700w0f7k0107obir7aze" }) {
          id
          richText
          selectPageTypeHeading
          headingColor {
            hex
          }
        }
      }
    `,
  },
};
</script>
<style lang="scss">
@import "../assets/colors.scss";
.loading-indicator {
  display: flex;
  justify-content: center;
  padding: 3rem 0;
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 4fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  // grid-auto-rows: minmax(100px, auto);
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 2fr));
  }
}
/* .item {
  grid-column: 1 / 3;
  grid-row: 1;
} */

.item {
  text-align: center;
  border-radius: 0.5rem;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
}

.navigation {
  &-link {
    text-decoration: none;
    color: $black;
    width: 100%;
  }
  &-text,
  &-icon {
    display: block;
    margin: 1.5rem auto;
  }
  &-icon {
    width: 6rem;
  }
  &-text {
    width: 12rem;
  }
}

.headline {
  text-align: center;
  max-width: 65%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 3rem;
  padding-top: 3rem;
  h2 {
    font-size: 3rem;
  }
}

.banner {
  background-color: $green;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
}

.markdown {
  h3 {
    margin-top: 3em;
    margin-bottom: 1em;
  }
}

h1,
h2,
h3,
h4 {
  font-weight: 200;
  margin-bottom: 0;
  margin-top: 0;
  color: var(--primary-color);
}
:root {
  --select-border: #777;
  --select-focus: blue;
  --select-arrow: var(--select-border);
}

.select {
  margin-top: 0.5rem;
  &-heading {
    font-size: 1.5em;
  }
  &-container {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 3rem;
    flex-direction: column;
    align-items: center;
  }
  min-width: 15ch;
  max-width: 30ch;

  border: 1px solid var(--select-border);
  border-radius: 0.25em;
  padding: 0.25em 0.5em;

  font-size: 1.25rem;
  cursor: pointer;
  line-height: 1.1;

  background-color: #fff;
  background-image: linear-gradient(to top, #f9f9f9, #fff 33%);
}

select:focus + .focus {
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid var(--select-focus);
  border-radius: inherit;
}

select[multiple] {
  padding-right: 0;
  height: 6rem;

  option {
    white-space: normal;
  }
}

.select--disabled {
  cursor: not-allowed;
  background-color: #eee;
  background-image: linear-gradient(to top, #ddd, #eee 33%);
}

label {
  font-size: 1.125rem;
  font-weight: 500;
}

.select + label {
  margin-top: 2rem;
}
</style>
